import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';

import { AuthEndpointsService } from './../_services/auth-endpoints.service';
import { DataService } from '../_services';

export const authGuard: CanActivateFn = (_route, state) => {
  const authService = inject(AuthEndpointsService);
  const dataService = inject(DataService);
  const router = inject(Router);
  const hasSessionToken = !!dataService.sessionData();

  if (authService.isLoggedIn && hasSessionToken) return true;

  // Keep auth state in sync when local storage was cleared externally.
  authService.isLoggedIn = false;

  authService.redirectUrl = state.url;
  router.navigate(['/login']);
  return false;
};
